import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import useSeo from "@/lib/useSeo";

const VALUES = [
  "Operasyonun içinde olmak",
  "Üye İşyerini kendi işimiz gibi sahiplenmek",
  "Çözüm odaklı hareket etmek",
  "Şeffaf ve ulaşılabilir olmak",
  "Teknoloji ile insan desteğini birleştirmek",
  "Uzun vadeli iş ortaklıkları kurmak",
];

export default function About() {
  useSeo({
    title: "Hakkımızda | Epersonel",
    description:
      "Epersonel, 2025'te kuruldu. Üye İşyerinin dışında değil, operasyonunuzun içindeyiz. Misyonumuz, vizyonumuz ve değerlerimiz.",
  });
  return (
    <>
      <section className="pt-16 pb-8">
        <div className="ep-container max-w-4xl">
          <p className="text-xs tracking-[0.3em] text-[#00F22E] font-medium mb-4">
            HAKKIMIZDA
          </p>
          <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight leading-tight">
            İşyerinizin Dışında Değil,{" "}
            <span className="text-[#00F22E]">Operasyonunuzun İçindeyiz.</span>
          </h1>
          <div className="mt-8 space-y-5 text-muted text-base md:text-lg leading-relaxed">
            <p>
              Epersonel, Üye İşyerlerinin dijital satış süreçlerinde yaşadığı
              farklı sorunları tek bir çözüm altında toplamak amacıyla 2025
              yılında kuruldu.
            </p>
            <p>
              Pazaryeri başvurularından ürün ve menü kurulumuna, fiyat-stok
              entegrasyonundan kampanya ve günlük operasyon yönetimine kadar
              zaman ve uzmanlık gerektiren süreçleri üstleniyoruz. Üye İşyerine
              özel web sipariş sistemleri ve mobil uygulamalar hazırlıyor,
              ihtiyaç duyulan operasyonlarda kurye çözümü de sunuyoruz.
            </p>
            <p>
              Kendimizi Üye İşyerinin dışında hizmet veren klasik bir ajans
              olarak görmüyoruz. Süreçleri uzaktan izleyen değil, operasyonun
              içine girerek uygulayan bir ekip olarak çalışıyoruz.
            </p>
          </div>
        </div>
      </section>

      <section className="py-14">
        <div className="ep-container max-w-4xl">
          <div className="ep-card p-8 md:p-10">
            <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight">
              Neden Epersonel?
            </h2>
            <p className="mt-4 text-muted leading-relaxed">
              Epersonel adı, "e-ticaret" kavramındaki "e" ile "personel"
              kelimesinin birleşiminden doğdu. Çünkü yalnızca yazılım veya
              danışmanlık sunmuyor; Üye İşyerinin dijital satış süreçlerini kendi
              personeli gibi sahipleniyor ve yürütüyoruz.
            </p>
            <p className="mt-6 font-display text-xl md:text-2xl font-semibold text-[#00F22E]">
              Dijital satış operasyonunuz için ihtiyaç duyduğunuz personel.
            </p>
          </div>
        </div>
      </section>

      <section className="py-14">
        <div className="ep-container max-w-4xl grid md:grid-cols-2 gap-6">
          <div className="ep-card p-8">
            <h3 className="font-display text-xl font-semibold">Misyonumuz</h3>
            <p className="mt-3 text-muted leading-relaxed">
              Üye İşyerlerinin dijital satışta karşılaştığı teknik ve operasyonel
              sorunları tek noktadan çözerek e-ticareti daha erişilebilir,
              düzenli ve yönetilebilir hâle getirmek.
            </p>
          </div>
          <div className="ep-card p-8">
            <h3 className="font-display text-xl font-semibold">Vizyonumuz</h3>
            <p className="mt-3 text-muted leading-relaxed">
              Türkiye genelindeki Üye İşyerlerinin pazaryerlerinde ve kendi satış
              kanallarında büyümesini sağlayan, güvenilir ve kapsamlı dijital
              operasyon markası olmak.
            </p>
          </div>
        </div>
      </section>

      <section className="py-14">
        <div className="ep-container max-w-4xl">
          <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight">
            Değerlerimiz
          </h2>
          <ul className="mt-8 grid sm:grid-cols-2 gap-3">
            {VALUES.map((v, i) => (
              <li
                key={i}
                className="flex items-start gap-2.5 text-white/95"
                data-testid={`about-value-${i}`}
              >
                <CheckCircle2 className="h-5 w-5 text-[#00F22E] mt-0.5 shrink-0" />
                {v}
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="py-16">
        <div className="ep-container max-w-4xl">
          <div className="ep-card p-8 md:p-12">
            <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight">
              Birlikte çalışalım mı?
            </h2>
            <div className="mt-6">
              <Link to="/basvuru" className="btn-primary" data-testid="about-cta">
                Ücretsiz Analiz İste <ArrowRight className="h-4 w-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
